import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/com/chat")({
  component: Outlet,
  beforeLoad: ({ context: { t } }) => ({
    getTitle: () => t("Chat"),
  }),
})
